import { ContactAddressParameterDto } from './contact-address-parameter-dto';

export class ContactAddressResultDto {
  addressTypeCode: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  countryCode: string;
  stateCode: string;
  postalCode: string;
  addressCSZ: string;

  toContactAddressParameter(): ContactAddressParameterDto {
    const addr = new ContactAddressParameterDto();
    addr.address1 = this.address1;
    addr.address2 = this.address2;
    addr.address3 = this.address3;
    addr.city = this.city;
    addr.stateCode = this.stateCode;
    addr.countryCode = this.countryCode;
    addr.zip = this.postalCode;
    return addr;
  }
}
